import type { INavigationHistory } from '@/store/types';

export const createNavigationHistory = (
  originUrl: string,
  gigId: number,
  adSourceId: number | null,
  refId: string | null,
  countryId: number | null,
  urlString?: string,
): INavigationHistory => {
  return {
    originUrl: originUrl,
    gigId: gigId,
    adSourceId: adSourceId,
    refId: refId,
    countryId: countryId,
    urlString: urlString,
  } as INavigationHistory;
};
